module.exports = __webpack_public_path__ + "media/icons/business-area-038d2e10.png";